import { Box } from '@material-ui/core';
import { BusinessOnboardingDetails } from '@nemuru-eng/js-api-client';
import { useFormContext } from 'react-hook-form';

import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { AutocompleteAddress } from '@/components/shared/components/NewContextForms/components/AutocompleteAddress/AutocompleteAddress';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';

interface BusinessAddressDetailsFormProps extends FormGridOptions {
  businessDetails: BusinessOnboardingDetails['businessDetails'];
}

export const BusinessAddressDetailsForm = ({
  businessDetails,
  fullWidth,
  fieldVariant,
}: BusinessAddressDetailsFormProps) => {
  if (!businessDetails) return null;

  if (useFormContext()) {
    return (
      <FormGridContainer fullWidth={fullWidth} fieldVariant={fieldVariant}>
        <AutocompleteAddress fieldVariant={fieldVariant} fieldNamesPrefix={'businessAddress'} hideAdditionalFields />
      </FormGridContainer>
    );
  }

  return (
    <Box pt={2}>
      <FormGridContainer fullWidth={fullWidth} fieldVariant={fieldVariant}>
        <TextFormField
          label={'STREET_ADDRESS'}
          value={businessDetails.address.formattedAddress}
          name={'businessAddress.address'}
        />
        <TextFormField
          label={'FLOOR_NUMBER'}
          value={businessDetails.address.floorNumber}
          name={'businessAddress.floorNumber'}
        />
        <TextFormField
          label={'DOOR_NUMBER'}
          value={businessDetails.address.doorNumber}
          name={'businessAddress.doorNumber'}
        />
        <TextFormField
          label={'BUILDING_LABEL'}
          value={businessDetails.address.building}
          name={'businessAddress.building'}
        />
      </FormGridContainer>
    </Box>
  );
};
